import { render } from "./ExpertChatMessage.vue?vue&type=template&id=c43038ce&scoped=true"
import script from "./ExpertChatMessage.vue?vue&type=script&lang=js"
export * from "./ExpertChatMessage.vue?vue&type=script&lang=js"

import "./ExpertChatMessage.vue?vue&type=style&index=0&id=c43038ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c43038ce"]])

export default __exports__